import { Helmet } from 'react-helmet';
import '../assets/css/Home.css';
import { Newsletter } from '../components/Newsletter';


export const Home = (): JSX.Element => {
    return (
        <>
            <Helmet>
                <title>Restaurang i Stockholm vid Vattnet med Modern Mat</title>
                <meta
                    name="description"
                    content="Upptäck en restaurang i Stockholm med utsikt, modern matlagning och livlig atmosfär. Perfekt för middag, event, AW och kvällar med underhållning."
                />

                <meta property="og:title" content="Restaurang i Stockholm vid Vattnet med Modern Mat" />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://frenchgroup.se" />
                <meta property="og:description" content="Upptäck en restaurang i Stockholm med utsikt, modern matlagning och livlig atmosfär. Perfekt för middag, event, AW och kvällar med underhållning." />
                <meta property="og:site_name" content="French Group" />

                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Restaurang i Stockholm vid Vattnet med Modern Mat" />
                <meta name="twitter:description" content="Upptäck en restaurang i Stockholm med utsikt, modern matlagning och livlig atmosfär. Perfekt för middag, event, AW och kvällar med underhållning." />
            </Helmet>
            <section id="home">
                <video playsInline autoPlay muted loop id="video" className="landing">
                    <source src="/videos/FrenchGroup_Hero_Maj_2024_D1.mp4" type="video/mp4" />
                </video>
                <Newsletter />
            </section>

            <section className="home-content">
                <div className="container">
                    <h1>Restaurang i Stockholm med Utsikt, Smaker och Levande Atmosfär</h1>
                    <p>
                        Att hitta en restaurang i Stockholm som kombinerar god mat, stämning och ett attraktivt läge kan vara en utmaning. Här möter du en plats som förenar moderna traditioner, avslappnad elegans och en miljö skapad för sociala upplevelser. Oavsett om du söker bra restauranger i Stockholm för en middag, en restaurang i Stockholm för affärslunch eller kanske ett ställe för kvällens festligheter, finns här en helhetsupplevelse som sträcker sig långt utöver en vanlig måltid.
                    </p>

                    <h2>En Stockholm Restaurang med Smaker från Grill och Hav</h2>
                    <p>
                        Maten är hjärtat i alla restauranger i Stockholm, men här ligger fokus på kontrasten mellan nordiska råvaror, franska influenser och amerikansk grillkultur. Menyn är levande och formas efter säsongens bästa råvaror. Gäster som söker restauranger stockholm med kvalitet uppskattar den tydliga hantverkskänslan i varje rätt.
                    </p>

                    <h3>Grillade Favoriter och Färska Råvaror</h3>
                    <p>
                        För dig som uppskattar grillad mat erbjuds rätter där kolgrillen lyfter smakerna och ger en modern twist. Här passar allt från hängmörat kött till skaldjur av hög kvalitet. Variationer för vegetarianer och fiskälskare finns alltid, vilket gör denna restaurang stockholm till ett tryggt val för grupper med olika preferenser.
                    </p>

                    <h3>Säsongsbetonad Meny för Alla Smaker</h3>
                    <p>
                        Menyn ändras regelbundet för att reflektera råvarornas bästa perioder. Det här är en restaurant stockholm som erbjuder många möjligheter till nya smakupplevelser varje gång du besöker den. För dig som söker en swedish restaurant stockholm med internationell känsla och öppenhet i matlagningen är detta ett utmärkt val.
                    </p>

                    <h2>Fine Dining Restaurant i En Modern Tolkning</h2>
                    <p>
                        Traditionell fine dining kan upplevas stelt, men här är ambitionen att hålla en hög kulinarisk nivå utan att tumma på en varm, social atmosfär. Det är en fine dining restaurant där miljön är lika viktig som maten. Tanken är att gäster ska kunna njuta av rätter av hög kvalitet i en miljö där man känner sig avslappnad och inspirerad.
                    </p>

                    <h3>Private Dining för Affärsmöten och Sällskap</h3>
                    <p>
                        Många söker restauranger i Stockholm som erbjuder avskildhet. Här finns möjlighet att samla kollegor, familj eller vänner i egna rum som ger en exklusiv känsla och full fokus på sällskapet. För företagsevent, födelsedagar eller viktiga middagar är detta en lösning som skapar en mer personlig upplevelse.
                    </p>

                    <h3>Inredning som Förhöjer Upplevelsen</h3>
                    <p>
                        Miljön är utformad med mjuka färger, varma material och omsorgsfull belysning. Det är en stockholm restaurang där atmosfären är lika genomtänkt som menyn. Rummet bjuder in till långa samtal, skratt och stunder som dröjer sig kvar.
                    </p>

                    <h2>Restauranger i Stockholm med Utsikt över Vattnet</h2>
                    <p>
                        För många gäster är utsikten en avgörande faktor när de söker bra restauranger stockholm. Den här platsen ligger vid vattnet och erbjuder en av stadens mest attraktiva terrasser under sommarhalvåret. Det är ett perfekt val för lunch, middag eller en lugn eftermiddag med något gott i glaset.
                    </p>

                    <h3>Terrass med Enastående Vyer</h3>
                    <p>
                        När solen ligger lågt skapas en stämning som är svår att hitta någon annanstans i city. Här finns en av de restauranger i stockholm som verkligen låter gäster koppla av med utsikt över stadens vackra inlopp.
                    </p>

                    <h2>After Work, Lounge och Cocktails</h2>
                    <p>
                        För dig som söker stockholm nightlife ger denna plats en perfekt kombination av mat, musik och mingel. Baren och loungen lockar både stockholmare och besökare som vill starta helgen på bästa sätt.
                    </p>

                    <h3>Lounge Bar Stockholm med Kreativa Drinkar</h3>
                    <p>
                        Mixologerna skapar cocktails som balanserar klassiska smaker och moderna influenser. För AW är det här en självklar mötesplats, särskilt för sällskap som vill ha både stämning och kvalitet.
                    </p>

                    <h3>Underhållning varje Vecka</h3>
                    <p>
                        Musik och atmosfär är centrala delar av upplevelsen. För gäster som söker underhållning stockholm eller underhållning till fest finns återkommande DJ-kvällar och temaevenemang som ger liv åt kvällarna. Det är också en populär destination för dig som vill upptäcka night clubs stockholm med en mer sofistikerad inramning.
                    </p>

                    <h2>Stockholm Nightlife och Live Music Venue</h2>
                    <p>
                        När kvällen övergår till natt blir stämningen mer intensiv. Många restauranger i Stockholm erbjuder mat eller musik, men här kombineras allt i ett sammanhållet koncept. För dig som söker ett live music venue för sena kvällar finns här återkommande evenemang och en publik som uppskattar internationell puls och energi.
                    </p>

                    <h3>Perfekt För Festkvällar och Större Sällskap</h3>
                    <p>
                        Här finns gott om plats för grupper, vilket gör lokalen attraktiv för företagsevent, kickoff och privata fester. Hospitality services anpassas efter sällskapets behov, från sittande middagar till mingel med musik och dans.
                    </p>

                    <h2>Event, Företagsmiddagar och Specialarrangemang</h2>
                    <p>
                        Platsen är känd för att kunna hantera både små och mycket stora sällskap. Det gör den till en stark kandidat för företag som söker en restaurang stockholm med kapacitet att skapa professionella och minnesvärda möten.
                    </p>

                    <h3>Skräddarsydda Upplevelser</h3>
                    <p>
                        Varje event planeras med fokus på detaljer. Oavsett om det handlar om en elegant gala, en kreativ kickoff eller en privat högtid ser teamet till att allt fungerar smidigt.
                    </p>

                    <h2>FAQs</h2>
                    <div className="faqs">
                        <div className="faq-item">
                            <h4>Vilka typer av sällskap passar bäst här?</h4>
                            <p>Restaurangen är anpassad för både små och stora grupper, från familjemiddagar till stora företagsarrangemang.</p>
                        </div>

                        <div className="faq-item">
                            <h4>Finns det vegetariska alternativ på menyn?</h4>
                            <p>Ja, det finns alltid genomtänkta vegetariska och fiskbaserade rätter som varierar efter säsong.</p>
                        </div>

                        <div className="faq-item">
                            <h4>Kan man boka bord online?</h4>
                            <p>Ja, bordsbokning erbjuds digitalt och rekommenderas särskilt under helger och sommarsäsong.</p>
                        </div>

                        <div className="faq-item">
                            <h4>Passar restaurangen för kvällsaktiviteter?</h4>
                            <p>Ja, den är populär för AW, cocktails, underhållning och kvällar som övergår i dans och musik.</p>
                        </div>

                        <div className="faq-item">
                            <h4>Har restaurangen uteservering?</h4>
                            <p>Ja, under sommarhalvåret finns en av stadens mest attraktiva terrasser med utsikt över vattnet.</p>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}